var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { createHook, createStore } from "react-sweet-state";
import { LoadingStateDefaults } from "framework/state/loadingstate";
import { loadAll, loadLast, update } from "framework/state/loader";
import { updateByCollectionResponse } from "framework/state/collection";
import { NoEntityError, updateByEntityResponse } from "framework/validation/validatableentity";
import { setEntityField } from "framework/state/setfield";
import { apiCreateMemberLoan, apiGetMemberLoan, apiGetMemberLoans, apiUpdateMemberLoanStatus } from "./endpoint";
import { apiGetClubs } from "common/clubs/endpoint";
import { AthleteDefaults } from "public_app/athlete/entity";
import { apiGetAthlete } from "public_app/athlete/endpoint";
var AthleteStateDefaults = __assign(__assign({}, LoadingStateDefaults), { collection: [], entity: AthleteDefaults, errors: __assign({}, NoEntityError) });
var loadAthlete = function (idt) { return function (store) {
    var loader = function () { return apiGetAthlete(idt); };
    var stateProducer = function (store, _, response) {
        store.setState(function (draft) {
            updateByCollectionResponse(draft.athlete, response);
            if (draft.athlete.collection.length > 0) {
                if (draft.athlete.collection[0].idt === idt) {
                    draft.athlete.entity = draft.athlete.collection[0];
                }
            }
        });
    };
    loadLast(store, loader, stateProducer, function (s) { return s.athlete; });
}; };
var NewMemberLoanSubmissionStateDefaults = __assign(__assign({}, LoadingStateDefaults), { entity: null, errors: __assign({}, NoEntityError) });
var submitNewMemberLoan = function () { return function (store) {
    var state = store.getState();
    var newLoanData = {
        memberIdt: state.newLoanForm.entity.memberIdt,
        hostingClubId: state.newLoanForm.entity.hostingClubId,
        fromDate: state.newLoanForm.entity.fromDate,
        toDate: state.newLoanForm.entity.toDate,
    };
    var updater = function () { return apiCreateMemberLoan(newLoanData); };
    var stateProducer = function (store, _, response) {
        store.setState(function (draft) {
            var _a;
            updateByEntityResponse(draft.newLoanSubmission, response);
            if (response.succeeded) {
                draft.newLoanForm.registeredMemberLoanId = (_a = draft.newLoanSubmission.entity.id) !== null && _a !== void 0 ? _a : null;
            }
            draft.newLoanForm.errors = draft.newLoanSubmission.errors;
        });
    };
    update(store, updater, stateProducer, function (s) { return s.newLoanSubmission; });
}; };
var NewMemberLoanFormStateDefaults = __assign(__assign({}, LoadingStateDefaults), { entity: {
        memberIdt: null,
        hostingClubId: null,
        fromDate: null,
        toDate: null,
    }, errors: __assign({}, NoEntityError), registeredMemberLoanId: null });
var setNewMemberLoanEntityField = function (field, value, validator, storeInvalidValue) { return function (store) {
    store.setState(function (draft) {
        setEntityField(draft.newLoanForm, field, value, validator, storeInvalidValue);
    });
    store.dispatch(resetNewMemberLoanSubmissionErrors());
}; };
var resetForm = function () { return function (store) {
    store.setState(function (draft) {
        draft.newLoanSubmission.errors = __assign({}, NoEntityError);
        draft.newLoanForm.entity.hostingClubId = null;
        draft.newLoanForm.entity.fromDate = null;
        draft.newLoanForm.entity.toDate = null;
        draft.newLoanForm.registeredMemberLoanId = null;
        draft.athlete = AthleteStateDefaults;
    });
}; };
var resetNewMemberLoanSubmissionErrors = function () { return function (store) {
    store.setState(function (draft) {
        draft.newLoanSubmission.errors = __assign({}, NoEntityError);
    });
}; };
var MemberLoansStateDefaults = __assign(__assign({}, LoadingStateDefaults), { collection: [], errors: __assign({}, NoEntityError) });
var loadMemberLoans = function (memberIdt, memberClubId, hostingClubId, status) {
    if (memberIdt === void 0) { memberIdt = null; }
    if (memberClubId === void 0) { memberClubId = null; }
    if (hostingClubId === void 0) { hostingClubId = null; }
    if (status === void 0) { status = null; }
    return function (store) {
        var loader = function () { return apiGetMemberLoans(memberIdt, memberClubId, hostingClubId, status); };
        var stateProducer = function (store, _, response) {
            store.setState(function (draft) {
                updateByCollectionResponse(draft.loans, response);
                if (!response.succeeded) {
                    draft.loans.collection = [];
                }
            });
        };
        loadAll(store, loader, stateProducer, function (s) { return s.loans; });
    };
};
var MemberLoanStateDefaults = __assign(__assign({}, LoadingStateDefaults), { entity: null, errors: __assign({}, NoEntityError) });
var loadMemberLoan = function (id) { return function (store) {
    var loader = function () { return apiGetMemberLoan(id); };
    var stateProducer = function (store, _, response) {
        if (response.succeeded) {
            store.setState(function (draft) {
                updateByEntityResponse(draft.loan, response);
            });
        }
    };
    loadAll(store, loader, stateProducer, function (s) { return s.loan; });
}; };
var updateMemberLoanStatus = function (id, status) { return function (store) {
    var updater = function () { return apiUpdateMemberLoanStatus(id, status); };
    var stateProducer = function (store, _, response) {
        store.setState(function (draft) {
            updateByEntityResponse(draft.loan, response);
        });
    };
    update(store, updater, stateProducer, function (s) { return s.loan; });
}; };
var ClubsStateDefaults = __assign(__assign({}, LoadingStateDefaults), { collection: [], errors: __assign({}, NoEntityError) });
var loadAllClubs = function () { return function (store) {
    var loader = function () { return apiGetClubs(); };
    var stateProducer = function (store, _, response) {
        store.setState(function (draft) {
            updateByCollectionResponse(draft.clubs, response);
            if (!response.succeeded) {
                draft.clubs.collection = [];
            }
        });
    };
    loadAll(store, loader, stateProducer, function (s) { return s.clubs; });
}; };
var StateDefaults = __assign(__assign({}, LoadingStateDefaults), { loans: MemberLoansStateDefaults, loan: MemberLoanStateDefaults, newLoanForm: NewMemberLoanFormStateDefaults, newLoanSubmission: NewMemberLoanSubmissionStateDefaults, clubs: ClubsStateDefaults, athlete: AthleteStateDefaults });
var store = createStore({
    initialState: StateDefaults,
    actions: {
        loadMemberLoans: loadMemberLoans,
        loadMemberLoan: loadMemberLoan,
        updateMemberLoanStatus: updateMemberLoanStatus,
        setNewMemberLoanEntityField: setNewMemberLoanEntityField,
        submitNewMemberLoan: submitNewMemberLoan,
        resetForm: resetForm,
        resetNewMemberLoanSubmissionErrors: resetNewMemberLoanSubmissionErrors,
        loadAllClubs: loadAllClubs,
        loadAthlete: loadAthlete,
    },
    name: "MemberLoans"
});
var useState = createHook(store);
export { StateDefaults as MemberLoansSStateDefaults, useState as useMemberLoans, };
